module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABUUlEQVQ4T82SwUoCURSG/3NmUIKMUoPauY02U9KiJ4iCgsKsRW8QReZzqJD0BlFk0iKh6A0iiplVa7dlWmQQ6sw9MdFoWDK2CLqbe+85nO/+/7mH8LluDtNRTZc7Ihr1Yt27iFQErcnpZL7i5cg7mIUdg0gzexV7cceR2fh69uoPASKX9sDrSv2xqbxXQtEA62+DpyCa81cgqAGqSIQ2QAQMcAKE8I+A872t4PiYNtHugaBJ+AIAGISAq8gF3D+0zIXtfMO9k1VImQAPC5zlD4CokpHMLXU30yqkzkC86AI0piNAPRvJ3BRZJ2mBoNwBoA5SFwTuWIBiCM+DEGoDCDFjNUPfAT7/2BNg25jpd5AYgWt0KWiwDaPaqJb9BikSjMSUDguEYMeCX1WP/H8BHKdrYIz82oXCk7GWCdNtcXdDU7QPwlDfEMGLw7IZT2QP3gEiZb4RkKjNeQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/sider/sider3-2.png
// module id = 976
// module chunks = 2